<template>
  <v-flex xs12>
    <v-btn color="success" @click="cpy(result)">Copy</v-btn>
    <v-btn color="error" @click="download(result)">Download</v-btn>
    <v-snackbar v-model="snackbar" color="success" :timeout="3000">
      Copy successful
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-flex>
</template>

<script>
export default {
  props: ['result'],
  data: () => ({
    snackbar: false
  }),
  methods: {
    cpy(result) {
      this.copy(result)
      this.snackbar = true
    }
  }
}
</script>